import { BaseComponent } from '@components/base.component';
import { Component, Input } from '@angular/core';
import { FaceoffsService } from '@services/faceoffs.service';
import { Subscription } from 'rxjs';
import { FaceoffSeason, FaceoffSubtournament, ParticipantFaceoffsData } from '@interfaces/faceoffs.interface';

@Component({
    selector: 'app-participant-faceoffs',
    templateUrl: './participant-faceoffs.component.html',
})
export class ParticipantFaceoffsComponent extends BaseComponent {
    @Input()
    public sportId: number;

    @Input()
    public sportName: string;

    @Input()
    public tournamentId: number | null;

    @Input()
    public participantId: number;

    public seasonId: number | null = null;

    public subtournamentId: number | null = null;

    public subscriber: Subscription;

    public data: ParticipantFaceoffsData | null = null;

    public constructor(
        private faceoffsService: FaceoffsService,
    ) {
        super();
    }

    protected readonly console = console;

    ngOnInit(): void {
        this.load();
    }

    public ngOnDestroy(): void {
        this.subscriber.unsubscribe();
    }

    private async load(): Promise<any> {
        if (!this.tournamentId) {
            return;
        }

        try {
            const data = await this.faceoffsService.getFaceoffs(
                this.tournamentId,
                this.participantId,
                this.seasonId,
                this.subtournamentId,
            );

            this.subscriber = data.subscribe((data: ParticipantFaceoffsData) => {
                this.seasonId = data.selected.season_id ?? null;
                this.subtournamentId = data.selected.subtournament_id ?? null;
                this.data = data;
            });
        } catch (e) {
            // console.log(e);
        }
    }


    get selectedSeason(): FaceoffSeason | null {
        return this?.data?.seasons.find((item: FaceoffSeason) => item.season.id === this.seasonId) ?? null;
    }

    get seasonName(): string | null {
        if (this.seasonId === null) {
            return null;
        }

        const season = this.selectedSeason;

        return season ? season.season.name : null;
    }

    get subtournamentName(): string | null {
        if (this.seasonId === null || this.subtournamentId === null) {
            return null;
        }

        const season = this.selectedSeason;

        if (!season) {
            return null;
        }

        const subtournament = season.subtournaments.find(
            (item: FaceoffSubtournament) => item.id === this.subtournamentId) ?? null;

        return subtournament?.name ?? null;
    }

    public onSeasonChange(e: Event): void {
        this.seasonId = +((e.target as HTMLInputElement).value);
        this.subtournamentId = null;
        this.load();
    }

    public onSubtournamentChange(e: Event): void {
        this.subtournamentId = +((e.target as HTMLInputElement).value);
        this.load();
    }
}
